import React from "react";
import Modal from "../../Common/Modal/Modal";
import { useSelector } from "react-redux";
import classes from "./RequestPasswordModal.module.scss";
import { FormattedMessage } from "react-intl";

const RequestPasswordModal = ({
  handleRequestPassword,
  requestPassword,
  handleRequestPasswordModal,
}) => {
  const loginState = useSelector((state) => state.loginReducer);
  const { requestNewLoader } = loginState;
  return (
    <Modal
      handleSubmit={handleRequestPassword}
      isOpen={requestPassword}
      heading={<FormattedMessage id="REQUEST_NEW_PASS" />}
      toggle={handleRequestPasswordModal}
      buttonLabel1={<FormattedMessage id="YES_TEXT" />}
      buttonLabel2={<FormattedMessage id="CANCEL_TEXT" />}
      width={"46.2"}
      height={"26.9"}
      loading={requestNewLoader}
    >
      <div className={classes.requestModal}>
        <div className={classes.requestModal__text}>
          Are you sure you want to reset the password?
        </div>
      </div>
    </Modal>
  );
};

export default RequestPasswordModal;
